var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.51562,
    y: 0.832031,
    width: 8.41176,
    height: 11.549,
    rx: 0.754902,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49372 1.13501C5.43958 1.27522 5.4099 1.42758 5.4099 1.58689V2.17113L1.73776 2.8997C1.59968 2.9271 1.50994 3.06125 1.53734 3.19934L3.49108 13.0466C3.51848 13.1847 3.65263 13.2744 3.79072 13.247L6.16253 12.7765C6.31633 12.8437 6.48621 12.881 6.6648 12.881H10.7733C10.7674 12.8823 10.7614 12.8835 10.7553 12.8847L3.98533 14.2279C3.30551 14.3628 2.64508 13.921 2.5102 13.2412L0.55646 3.39395C0.421582 2.71413 0.863338 2.0537 1.54315 1.91882L5.49372 1.13501Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23926 12.759C9.24632 12.7605 9.25342 12.762 9.26054 12.7634L16.0307 14.1059C16.7105 14.2407 17.3709 13.7989 17.5057 13.1191L19.4585 3.27161C19.5933 2.59179 19.1514 1.93139 18.4716 1.79658L14.1911 0.947754C14.2625 1.10544 14.3022 1.28052 14.3022 1.46488V1.98927L18.2771 2.77749C18.4152 2.80487 18.5049 2.93901 18.4776 3.0771L16.5248 12.9246C16.4974 13.0627 16.3633 13.1524 16.2252 13.125L13.6374 12.6119C13.4615 12.7058 13.2606 12.759 13.0473 12.759H9.23926Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShades);
export default __webpack_public_path__ + "static/media/shades.eca10f0196cfa327f00527f05fa4aebe.svg";
export { ForwardRef as ReactComponent };